// extracted by mini-css-extract-plugin
export default {"root":"SubscriptionPlanSelectorV3_root-o9V","plans":"SubscriptionPlanSelectorV3_plans-A6B","button":"SubscriptionPlanSelectorV3_button-gNR"};